import ChevronDownIcon from '@/assets/icons/chevron/chevron-down.svg';
import ChevronUpIcon from '@/assets/icons/chevron/chevron-up.svg';
import ChevronRightIcon from '@/assets/icons/chevron/chevron-right.svg';
import ChevronLeftIcon from '@/assets/icons/chevron/chevron-left.svg';

export { ChevronDownIcon, ChevronUpIcon, ChevronRightIcon, ChevronLeftIcon };
